import { CustomerEditScreen } from '../features/customers/CustomerEditScreen'
import { useShell } from '../app/outlet'

export function CustomerEditPage() {
  const { toast } = useShell()
  return <CustomerEditScreen onToast={toast} />
}
